// Lib
import * as _ from 'lodash';
import { put, call, takeLatest } from "redux-saga/effects";

// Constants
import * as ACTIONS from "./actionTypes";

// Functions
import { parseAPIDealerInfo } from './utils';
import { createAPINetworkInstance } from 'common/api';

// Types
import { ActionGetDealerInfoAPI, getDealerInfoAPIError, getDealerInfoAPISuccess, } from './actions';
import { DealerInfo } from './types';

function* getDealerInfo(action: ActionGetDealerInfoAPI) {
    try {
        const { listingId } = action
        const { data } = yield call(createAPINetworkInstance().get, `/listing/${listingId}/info`);
        const dealerinfoitem: DealerInfo = parseAPIDealerInfo(data);
        yield put(getDealerInfoAPISuccess(dealerinfoitem));
    } catch (err) {
        yield put(getDealerInfoAPIError(err));
    }
}

export default function* dealerinfoSagas() {
    yield takeLatest(ACTIONS.GET_DEALERINFO_API_REQUEST, getDealerInfo);
}
